import { ApplicationError } from '@ps-smart-cp/ppfw-client';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import { fetchTokensBy } from '../features/login';
import type { ClassifiedError } from '../types';

function classifyError(description: string | null): ClassifiedError {
  const desc = description || '';

  if (desc.match(/No matching user/i)) {
    return {
      summary:
        'IdPから提供されたemailに対応するログインユーザーが存在しません。\n事前にユーザーを作成してからお試しください。',
      checklist: [],
    };
  }

  if (desc.match(/Missing required claim/i)) {
    return {
      summary: '必須の属性（email）がIdPから提供されていません。\nIdP設定をご確認ください。',
      checklist: [],
    };
  }

  if (desc.match(/client/i)) {
    return {
      summary:
        'OIDC クライアント設定に不備があります。\nClient ID または Client Secret が正しく設定されているかご確認ください。',
      checklist: [],
    };
  }

  return {
    summary: '認証中にエラーが発生しました。',
    checklist: [
      'IdPに設定したAudience (エンティティID) およびACS URLが、当サービスから提供された値と一致していること',
      'SAML認証の場合、署名アルゴリズムがSHA-256であること',
      'NameIDのFormatがemailであること',
    ],
  };
}

// TODO: AUTH-1329 SSO設定をしてからすぐにSSOサインインすると、cognitoのmanagedエラー画面に遷移する問題を解消する
// TODO: AUTH-1330 SSOの持続セッションが切れた時のエラーハンドリングを実装する
export function AuthCallbackPage() {
  const isMounted = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (isMounted.current) return;
    isMounted.current = true;

    const fetchTokens = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const error = urlParams.get('error');
      const errorDescription = urlParams.get('error_description');
      const code = urlParams.get('code');
      const organizationId = sessionStorage.getItem('organizationId');

      if (error) {
        const { summary, checklist } = classifyError(errorDescription);
        navigate('/error', {
          state: { summary, checklist },
        });
        return;
      }

      if (organizationId && code) {
        try {
          await fetchTokensBy(organizationId, code);
          navigate('/fa/main-menu');
        } catch (e) {
          if (e instanceof ApplicationError) {
            navigate('/error', { state: { summary: e.message } });
            return;
          }

          navigate('/error', {
            state: { title: 'システムエラー', summary: 'システムエラーが発生しました。' },
          });
          return;
        }
      }
    };

    void fetchTokens();
  }, [navigate]);

  return <div>Processing...</div>;
}
